<template>
  <footer
    :class="brandService.getName() === Brand.HIS ? 'bg-brand-secondary' : 'bg-black'"
    class="w-full"
  >
    <div class="pt-12 pb-32 lg:pb-10 px-6 lg:px-12 flex flex-col flex-col-reverse lg:flex-row max-w-screen-2xl mx-auto justify-between">
      <div class="text-left justify-start lg:pt-0 pt-6">
          <img class="h-6 w-auto pr-10" :src="brandService.getLogoDark()" />
          <img class="h-11 w-auto" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/unitigroupsm.png" />
        <p class="font-poppins text-md font-thin text-white my-0 py-1">&copy; {{ year }} &bull; {{ brandTitle }} &bull; All rights reserved.</p>
      </div>
      <div class="text-right justify-end flex flex-col lg:flex-row pt-0 lg:pt-2">
        <div v-for="item, index in main" :key="index" class="lg:px-2 py-2 flex-row flex text-right justify-start">
          <router-link :to="item.href" class="text-sm text-white no-underline font-poppins font-normal">
            {{ item.name }}
          </router-link>
          <div v-if="index < main.length - 1" class="text-white pl-4 lg:block hidden"> | </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { DefineComponent, defineProps, ref } from 'vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

type MainLink = {
  name: string,
  href: string
}

type SocialLink = {
  name: string,
  href: string,
  icon: DefineComponent
}

defineProps<{
  main: Array<MainLink>,
  social?: Array<SocialLink>
}>();

const brandTitle = brandService.getTitle();
const year = ref(new Date().getFullYear());

</script>
